import { takeLatest, all, call, put } from "redux-saga/effects";

import { request } from "@app/services";
import { contactUs, contactUsFailed, contactUsSuccess } from "./slice";
import * as endPoints from "./endpoints";

function* contactUsSaga(action: ReturnType<typeof contactUs>): any {
  try {
    const { name, email, message, state, city, zipCode } = action.payload;
    const response = yield call(request.post, endPoints.contactUs, {
      name,
      email,
      message,
      state,
      city,
      zipCode,
    });
    yield put(contactUsSuccess(response));
  } catch (error: any) {
    yield put(contactUsFailed(error));
  }
}

function* contactUsSagas() {
  yield all([takeLatest(contactUs, contactUsSaga)]);
}

export { contactUsSagas };
